<header class="page-header">
  <h1>Census Action Labels</h1>
  <p class="subtitle">
    Group action codes into labels that cover one or more PCC action types. The
    <button type="button" class="link-btn" (click)="goToAdtReport()">ADT Report</button>
    aggregates events by these labels.
  </p>
</header>

<section class="create-form">
  <h3 class="create-form__title">Create label</h3>
  <div class="create-form__row">
    <app-census-multiselect-dropdown
      [options]="actionTypeOptions"
      [selected]="newLabelTypes"
      [summary]="newLabelTypes.length ? newLabelTypes.join(' + ') : 'Select action types…'"
      (selectedChange)="setNewLabelTypes($event)"
    ></app-census-multiselect-dropdown>
    <input
      type="text"
      placeholder="Label name (e.g. Readmission)"
      [(ngModel)]="newLabelName"
      (keyup.enter)="createLabel()"
      class="text-input"
    />
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="!canCreateLabel()"
      (click)="createLabel()"
    >Save</button>
  </div>
</section>

<div *ngIf="loading" class="loading-banner">Loading…</div>

<div *ngIf="!loading" class="table-wrap">
  <table class="labels-table">
    <thead>
      <tr>
        <th class="move-col">Move</th>
        <th class="type-col">Action Type</th>
        <th class="label-col">Codes label</th>
        <th class="codes-col">Codes</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let label of sortedLabels; trackBy: trackByLabelId">
        <td class="move-col">
          <!-- Reorder controls. Flat order across all labels;
               first/last rows have their up/down disabled. Updates optimistic. -->
          <div class="move-buttons">
            <button
              type="button"
              class="btn btn-ghost move-btn"
              [disabled]="!canMoveUp(label)"
              [title]="canMoveUp(label) ? 'Move up' : 'Already at the top'"
              aria-label="Move up"
              (click)="moveLabel(label, 'up')"
            >▲</button>
            <button
              type="button"
              class="btn btn-ghost move-btn"
              [disabled]="!canMoveDown(label)"
              [title]="canMoveDown(label) ? 'Move down' : 'Already at the bottom'"
              aria-label="Move down"
              (click)="moveLabel(label, 'down')"
            >▼</button>
          </div>
        </td>

        <td class="type-col">{{ label.actionTypes.join(' + ') }}</td>

        <td class="label-col">
          <ng-container *ngIf="editingLabelId === label._id; else labelView">
            <div class="label-edit">
              <input
                #renameInput
                type="text"
                [(ngModel)]="editingLabelName"
                (keyup.enter)="saveEdit(label)"
                (keyup.escape)="cancelEdit()"
                class="text-input"
              />
              <button type="button" class="btn btn-primary" (click)="saveEdit(label)">Save</button>
              <button type="button" class="btn btn-ghost" (click)="cancelEdit()">Cancel</button>
            </div>
          </ng-container>
          <ng-template #labelView>
            <div class="label-cell">
              <span class="label-name">{{ label.name }}</span>
              <span class="spacer"></span>
              <button type="button" class="btn btn-ghost" (click)="startEdit(label)" aria-label="Rename">✏️</button>
              <button
                type="button"
                class="btn btn-ghost danger"
                title="Delete"
                (click)="deleteLabel(label)"
                aria-label="Delete"
              >🗑️</button>
            </div>
          </ng-template>
        </td>

        <td class="codes-col">
          <div class="chips">
            <span
              *ngFor="let code of codesForLabel(label); trackBy: trackByCode"
              class="chip"
              [title]="code.longDesc"
            >
              <code>{{ code.shortDesc }}</code>
              <button
                type="button"
                class="chip-remove"
                aria-label="Remove"
                (click)="removeCodeFromLabel(code, label)"
              >×</button>
            </span>

            <div class="add-code-wrap">
              <button
                type="button"
                class="btn btn-ghost add-code-btn"
                (click)="toggleAddDropdown(label)"
                [disabled]="codesNotInLabel(label).length === 0"
              >+ Add code</button>
              <div
                *ngIf="openAddDropdownLabelId === label._id && codesNotInLabel(label).length > 0"
                class="add-code-dropdown"
              >
                <button
                  *ngFor="let code of codesNotInLabel(label); trackBy: trackByCode"
                  type="button"
                  class="add-code-option"
                  (click)="addCodeToLabel(code, label)"
                  [title]="code.longDesc"
                >
                  <code>{{ code.shortDesc }}</code>
                  <span class="add-code-desc">{{ code.longDesc }}</span>
                  <span *ngIf="extraLabelNames(code).length > 0" class="add-code-current">
                    on: {{ extraLabelNames(code).join(', ') }}
                  </span>
                </button>
              </div>
            </div>
          </div>
        </td>
      </tr>
      <tr *ngIf="sortedLabels.length === 0">
        <td colspan="4" class="empty-row">No labels yet. Create one above.</td>
      </tr>
    </tbody>
  </table>
</div>

<ng-template #confirmDeleteDialog let-data let-ref="dialogRef">
  <nb-card class="confirm-delete-dialog">
    <nb-card-header>Delete label</nb-card-header>
    <nb-card-body>
      Delete label "{{ data?.label?.name }}"? Codes assigned only to it will be left unassigned and excluded from the report until you label them again.
    </nb-card-body>
    <nb-card-footer class="confirm-delete-footer">
      <button type="button" class="btn btn-secondary" (click)="ref.close(false)">Cancel</button>
      <button type="button" class="btn btn-danger" (click)="ref.close(true)">Delete</button>
    </nb-card-footer>
  </nb-card>
</ng-template>
